// extracted by mini-css-extract-plugin
export var actions = "recipe-note-module--actions--f0136";
export var container = "recipe-note-module--container--7762f";
export var content = "recipe-note-module--content--e21b8";
export var date = "recipe-note-module--date--3d01b";
export var deleteButton = "recipe-note-module--delete-button--b6808";